
import { Method as apiMethod } from 'axios'

export const adminEndpoints = {
  users: {
    method: 'GET' as apiMethod,
    url: '/user/page'
  }
}
